<template>
    <v-card class="mx-auto" shaped elevation="7">
        <v-card-title>
            Informe De Movimiento De Póliza
        </v-card-title>
        <v-container fluid grid-list-sm>
            <v-row dense>
                <v-col cols="12" sm="4" md="4">
                    <v-autocomplete label="Canal *" color="textbox" v-model="obSearch.idCanal"
                        :items="listGeneral.listCanal" item-value="idCanal" item-text="canal"
                        @change="listarAseguradora" outlined dense />
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-autocomplete label="Aseguradora" color="textbox" v-model="obSearch.idAseguradora"
                        :items="listGeneral.listAseguradora" item-value="idAseguradora" item-text="aseguradora"
                        @change="onListarSeguro" outlined dense />
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-autocomplete label="Seguro" color="textbox" v-model="obSearch.idSeguro"
                        :items="listGeneral.listSeguro" item-text="seguro" item-value="idSeguro" 
                        @change="onListarBroker" outlined dense />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" sm="4" md="4">
                    <v-autocomplete label="Broker" color="textbox" v-model="obSearch.idBroker"
                        :items="listGeneral.listBroker" item-text="broker" item-value="idBroker" outlined dense />
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-text-field label="Póliza" color="textbox" v-model="obSearch.poliza" outlined dense/>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-autocomplete label="Estado *" color="textbox" v-model="obSearch.idEstado"
                        :items="listGeneral.listEstado" item-text="nombre_estado" item-value="id_estado" outlined
                        dense />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12" sm="4" md="4">
                    <v-dialog ref="dialogFechaDesde" v-model="objDate.desde.abrirModal"
                        :return-value.sync="obSearch.fechaDesde" persistent width="330px">
                        <template v-slot:activator="{ on }">
                            <v-text-field color="textbox" v-model="obSearch.fechaDesde" label="Fecha Desde *"
                                prepend-inner-icon="event" readonly outlined dense v-on="on" />
                        </template>
                        <v-date-picker color="primary" v-model="obSearch.fechaDesde" scrollable locale="es">
                            <v-spacer></v-spacer>
                            <v-btn outlined dense rounded color="danger" @click="objDate.desde.abrirModal = false"
                                v-html="'Salir'"></v-btn>
                            <v-btn rounded dark color="primary"
                                @click="$refs.dialogFechaDesde.save(obSearch.fechaDesde);" v-html="'Guardar Fecha'">
                            </v-btn>
                        </v-date-picker>
                    </v-dialog>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <v-dialog ref="dialogFechaHasta" v-model="objDate.hasta.abrirModal"
                        :return-value.sync="obSearch.fechaHasta" persistent width="340px">
                        <template v-slot:activator="{ on }">
                            <v-text-field color="textbox" v-model="obSearch.fechaHasta" label="Fecha Hasta *"
                                prepend-inner-icon="event" readonly outlined dense v-on="on" />
                        </template>
                        <v-date-picker color="primary" v-model="obSearch.fechaHasta" scrollable locale="es">
                            <v-spacer></v-spacer>
                            <v-btn outlined dense rounded color="danger" @click="objDate.hasta.abrirModal = false"
                                v-html="'Salir'"></v-btn>
                            <v-btn rounded dark color="primary"
                                @click="$refs.dialogFechaHasta.save(obSearch.fechaHasta);" v-html="'Guardar Fecha'">
                            </v-btn>
                        </v-date-picker>
                    </v-dialog>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-tooltip right color="primary">
                        <template v-slot:activator="{ on }">
                            <v-btn class="text-right mt-1" outlined color="primary" @click="onListarMovimientos" v-on="on" :disabled="disabled">
                                Buscar<v-icon>search</v-icon>
                            </v-btn>
                        </template>
                        <span>Buscar</span>
                    </v-tooltip>
                </v-col>
            </v-row>

            <v-row dense>
                <v-col v-if="_.size(listGeneral.detalle) == 0" cols="12" sm="12"></v-col>
                <v-col v-else cols="12" sm="12">
                    <v-btn rounded color="primary" dark @click="exportar('tableInfo','Informe de Movimiento')">Exportar a XLSX</v-btn>
                </v-col>
            </v-row>

            <v-row dense>
                <v-col cols="12" sm="6">
                    <v-checkbox label="Agrupar por Certificado" v-model="group" dense color="primary"></v-checkbox>
                </v-col>
                <v-col cols="12" sm="6">
                    <v-text-field label="Buscar" color="textbox" v-model="obSearch.search" clearable dense
                        prepend-inner-icon="search" />
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12">
                    <v-data-table :search="obSearch.search" :headers="listGeneral.cabecera"  :group-by="group ? ['idCertificado']: []"
                        :items="listGeneral.detalle" class="elevation-3" id="tableInfo">

                        <template v-slot:no-results>
                            Tu búsqueda de "<span v-html="obSearch.search"></span>" no arrojó resultados.
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
    export default {
        name: 'InformeMovimientoView',
        data: () => ({
            objDate: {
                desde: {
                    abrirModal: false
                },
                hasta: {
                    abrirModal: false
                }
            },
            obSearch: {
                idCanal: null,
                idAseguradora: null,
                idSeguro: null,
                idBroker: null,
                poliza: null,
                idPoliza: null,
                fechaDesde: moment().format('YYYY-MM-DD'),
                fechaHasta: moment().format('YYYY-MM-DD'),
                idEstado: null,
                search:null
            },
            listGeneral: {},
            parametro: {},
            group: false
        }),
        created() {
            axios.post(`${BASE_URI}administrador/informe-movimiento/cargaGeneral`, {})
                .then((r) => {
                    if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                    if (_.size(_.get(r, ['data', 'data'], [])) == 0) throw _.get(r, ['data', 'mensaje'],mensajeEstandar.errorPeticion);
                        this.$set(this, 'listGeneral', r.data.data.listas);
                        this.$set(this, 'parametro', r.data.data.parametros);
                        this.obSearch.idCanal = this.listGeneral.listCanal[0].idCanal;
                        this.obSearch.idEstado = _.toString(this.parametro.id_estado_default);
                })
                .catch((e) => {
                    mensajesAlerta(e, 'E');
                });
        },
        computed:{
            disabled(){
                return _.size(this.obSearch.idBroker) == 0 ? true : false;
            }
        },
        methods: {
            listarAseguradora(event) {
                var error = 'E';
                this.clearVariable(['idAseguradora','idSeguro','idBroker']);
                this.clearArray(['detalle','listAseguradora','listSeguro','listBroker']);

                axios.post(`${BASE_URI}administrador/poliza/listar`,{opcion:'LISTAR_ASEGURADORA_X_CANAL',idCanal:this.obSearch.idCanal })
                     .then((r)=>{
                        if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                        if (_.size(_.get(r, ['data', 'data'], [])) == 0) { error = 'I'; throw _.get(r, ['data', 'mensaje'],mensajeEstandar.errorPeticion); }
                            this.listGeneral.listAseguradora = r.data.data;
                     })
                     .catch((e) =>{
                         mensajesAlerta(e,error);
                     });
            },
            onListarSeguro(event) {
                if(!_.isUndefined(event)){
                    this.clearVariable(['idSeguro','idBroker']);
                    this.clearArray(['detalle','listSeguro','listBroker']);
                    var objeto = _.merge({},{opcion:'LISTAR_SEGURO_X_ASEGURADORA_CANAL'},_.pick(this.obSearch,['idCanal','idAseguradora']));
                    var error = 'E';
                    
                    axios.post(`${BASE_URI}administrador/poliza/listar`,objeto)
                         .then((r)=>{
                            if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                            if (_.size(_.get(r, ['data', 'data'], [])) == 0) { error = 'I'; throw _.get(r, ['data', 'mensaje'],mensajeEstandar.errorPeticion); }
                                this.listGeneral.listSeguro = r.data.data;
                         })
                         .catch((e) =>{
                             mensajesAlerta(e,error);
                         });

                }
            },
            onListarBroker(event){
                if(!_.isUndefined(event)){
                    this.clearVariable(['idBroker']);
                    this.clearArray(['detalle']);
                    var objeto = _.merge({},{opcion:'LISTAR_BROKER_X_CANAL_ASEG_SEGURO'},_.pick(this.obSearch,['idCanal','idAseguradora','idSeguro']));
                    var error = 'E';

                    this.listGeneral.listBroker = [];
                    axios.post(`${BASE_URI}administrador/poliza/listar`,objeto)
                         .then((r)=>{
                            if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                            if (_.size(_.get(r, ['data', 'data'], [])) == 0) { error = 'I'; throw _.get(r, ['data', 'mensaje'],mensajeEstandar.errorPeticion); }
                                this.listGeneral.listBroker = r.data.data;
                         })
                         .catch((e) =>{
                             mensajesAlerta(e,error);
                         });
                }
            },
            onListarMovimientos(event){
                if(!_.isUndefined(event)){
                    var error = 'E';
                    this.listGeneral.detalle = [];

                    axios.post(`${BASE_URI}administrador/informe-movimiento/listar`,_.merge({},{opcion:'LISTAR'},_.omit(this.obSearch,'search')))
                         .then((r)=>{
                            if (_.get(r, ['data','existeError'], true)) throw mensajeEstandar.errorPeticion;
                            if (_.size(_.get(r, ['data', 'data'], [])) == 0) { error = 'I'; throw _.get(r, ['data','mensaje'],mensajeEstandar.errorPeticion); }
                                var lista = _.cloneDeep(r.data.data);
                                var ob = {
                                            idCertificado: "", canal: "", poliza: "",  aseguradora: "", broker: "", contratante: "",
                                            asegurado: "", nroDocumento: "", documento: "", fechaDesde: "", fechaHasta: "Total:", valorAsegurado: "",
                                            primaNeta: "", idTipoMovimiento: ""
                                        }

                                lista = _.map(lista,(v)=>{  
                                                            v.valorAsegurado = parseFloat(v.valorAsegurado); 
                                                            v.primaNeta = parseFloat(v.primaNeta);
                                                            v.idTipoMovimiento = parseInt(v.idTipoMovimiento);
                                                            return v;
                                                        });

                                // Se separa los registros de las ventas y devoluciones
                                var listaVentas = _.filter(_.cloneDeep(lista),(v)=>{ return parseInt(v.idTipoMovimiento) != parseInt(this.parametro.id_tipo_movimiento_exclusion) });
                                var listaDevolucion = _.filter(_.cloneDeep(lista),{'idTipoMovimiento':this.parametro.id_tipo_movimiento_exclusion });

                                // Se suma los valores
                                ob.valorAsegurado = _.round((_.sumBy(listaVentas,'valorAsegurado') - _.sumBy(listaDevolucion,'valorAsegurado')),2);
                                ob.primaNeta      = _.round((_.sumBy(listaVentas,'primaNeta') - _.sumBy(listaDevolucion,'primaNeta')),2);

                                this.listGeneral.detalle = _.cloneDeep(r.data.data);
                                this.listGeneral.detalle.push(ob);
                                this.listGeneral.detalle = _.map(_.cloneDeep(this.listGeneral.detalle),(v) =>{
                                                                    if(_.toNumber(v.idTipoMovimiento) == _.toNumber(this.parametro.id_tipo_movimiento_exclusion)){
                                                                        v.valorAsegurado = `- $${Number.parseFloat(v.valorAsegurado).toFixed(2)}`;
                                                                        v.primaNeta      = `- $${Number.parseFloat(v.primaNeta).toFixed(2)}`
                                                                    }else{
                                                                        v.valorAsegurado = `$${Number.parseFloat(v.valorAsegurado).toFixed(2)}`;
                                                                        v.primaNeta      = `$${Number.parseFloat(v.primaNeta).toFixed(2)}`
                                                                    }

                                                                    return v;
                                                                });

                                
                         })
                         .catch((e)=>{
                             mensajesAlerta(e,error);
                         });
                }
            },
            clearVariable(arrayKeys){
                _.forEach(arrayKeys,(v,k) =>{
                    this.$set(this.obSearch,v,null);
                });
            },
            clearArray(arrayKeys){
                _.forEach(arrayKeys,(v,k) =>{
                    this.$set(this.listGeneral,v,[]);
                });
            },
        }
    }
</script>

<style>

</style>